import Stack from '@mui/material/Stack'

import PlanUsageActivityHeatmap from './PlanUsageActivityHeatmap'
import PlanUsagePlanAndUpgradeRow from './PlanUsagePlanAndUpgradeRow'
import PlanUsageTokenAllowanceCard from './PlanUsageTokenAllowanceCard'

/**
 * Settings ▸ Overview — plan tiles, activity heatmap, and token meter.
 * Visual tokens follow the product shell; typography uses the global MUI theme.
 */
export default function PlanUsageSettingsContent() {
  return (
    <Stack spacing={1} sx={{ width: '100%', mt: '14px', alignItems: 'stretch' }}>
      <PlanUsagePlanAndUpgradeRow />
      <PlanUsageActivityHeatmap />
      <PlanUsageTokenAllowanceCard />
    </Stack>
  )
}
